export default "__VITE_ASSET__cc93033a__"